export const signatureBlockTestIds = {
  block: 'signature-block-button',
};
